import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
//
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { queryInspectionAnalysis } from '@/api/api';
export default {
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    top: {
      type: String,
      default: '30px'
    },
    position: {
      type: String,
      default: 'absolute'
    },
    left: {
      type: String,
      default: '20px'
    },
    marginLeft: {
      type: String,
      default: '0px'
    },
    type: {},
    id: {},
    queryType: {}
  },
  data: function data() {
    return {
      chart: 'chart10'
    };
  },
  watch: {
    id: {
      handler: function handler(val) {
        this.querySewageQuotaList(this.type, val, this.queryType);
      },
      immediate: true
    },
    queryType: function queryType(val) {
      this.querySewageQuotaList(this.type, this.id, val);
    }
  },
  methods: {
    initBarChart: function initBarChart(data) {
      // mock 数据
      var dataArr = {
        xdata: data.xData,
        result: [{
          name: '日常巡检',
          data: data.data1
        }, {
          name: '问题日常巡检',
          data: data.data2
        }, {
          name: '周巡检',
          data: data.data3
        }, {
          name: '问题周巡检',
          data: data.data4
        }]
      }; // 头部菱形

      var diamondData = dataArr.result.reduce(function (pre, cur, index) {
        pre[index] = cur.data.map(function (el, id) {
          return el + (pre[index - 1] ? pre[index - 1][id] : 0);
        });
        return pre;
      }, []); // color

      var color = [[{
        offset: 0,
        color: "#dc0707"
      }, {
        offset: 0.5,
        color: "#dc0707"
      }, {
        offset: 0.5,
        color: "#af0808"
      }, {
        offset: 1,
        color: "#af0808"
      }], [{
        offset: 0,
        color: "#f67c20"
      }, {
        offset: 0.5,
        color: "#f67c20"
      }, {
        offset: 0.5,
        color: "#cc681e"
      }, {
        offset: 1,
        color: "#cc681e"
      }], [{
        offset: 0,
        color: "#efff37"
      }, {
        offset: 0.5,
        color: "#efff37"
      }, {
        offset: 0.5,
        color: "#d5e700"
      }, {
        offset: 1,
        color: "#d5e700"
      }], [{
        offset: 0,
        color: "#32ffee"
      }, {
        offset: 0.5,
        color: "#32ffee"
      }, {
        offset: 0.5,
        color: "#00e8d5"
      }, {
        offset: 1,
        color: "#00e8d5"
      }], [{
        offset: 0,
        color: "#46c9ff"
      }, {
        offset: 0.5,
        color: "#46c9ff"
      }, {
        offset: 0.5,
        color: "#00b4ff"
      }, {
        offset: 1,
        color: "#00b4ff"
      }], [{
        offset: 0,
        color: "#54a0ff"
      }, {
        offset: 0.5,
        color: "#54a0ff"
      }, {
        offset: 0.5,
        color: "#1f83ff"
      }, {
        offset: 1,
        color: "#1f83ff"
      }]]; // series

      var series = dataArr.result.reduce(function (p, c, i, array) {
        p.push({
          z: i + 1,
          stack: '总量',
          type: 'bar',
          name: c.name,
          barGap: '-100%',
          barWidth: 30,
          data: c.data,
          itemStyle: {
            color: {
              type: 'linear',
              x: 0,
              x2: 1,
              y: 0,
              y2: 0,
              colorStops: color[i]
            }
          }
        }, {
          z: i + 10,
          type: 'pictorialBar',
          symbolPosition: 'end',
          symbol: 'diamond',
          symbolOffset: [0, '-50%'],
          symbolSize: [30, 10],
          data: diamondData[i],
          itemStyle: {
            color: {
              type: 'linear',
              x: 0,
              x2: 1,
              y: 0,
              y2: 0,
              colorStops: color[i]
            }
          },
          tooltip: {
            show: false
          }
        }); // 是否最后一个了？

        if (p.length === array.length * 2) {
          p.push({
            z: array.length * 2,
            type: "pictorialBar",
            symbolPosition: "start",
            data: dataArr.result[0].data,
            symbol: "diamond",
            symbolOffset: ["0%", "50%"],
            symbolSize: [30, 10],
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                x2: 1,
                y: 0,
                y2: 0,
                colorStops: color[0]
              }
            },
            tooltip: {
              show: false
            }
          });
          return p;
        }

        return p;
      }, []); // tooltip

      var tooltip = {
        trigger: "axis"
      }; // legend

      var legend = {
        data: dataArr.result.map(function (item) {
          return item.name;
        }),
        textStyle: {
          fontSize: 14,
          color: '#fff'
        },
        itemWidth: 25,
        itemHeight: 15,
        itemGap: 5,
        top: '5%',
        left: '5%',
        // 禁止点击
        selectedMode: false
      }; // grid

      var grid = {
        top: '25%',
        left: '10%',
        right: '3%',
        bottom: '10%'
      }; // xAxis

      var xAxis = {
        axisTick: {
          show: true
        },
        axisLine: {
          lineStyle: {
            color: 'rgba(255,255,255, .2)'
          }
        },
        axisLabel: {
          textStyle: {
            fontSize: 12,
            color: '#fff'
          }
        },
        data: dataArr.xdata
      }; // yAxis

      var yAxis = [{
        splitLine: {
          lineStyle: {
            color: 'rgba(255,255,255, .05)'
          }
        },
        axisLine: {
          show: false
        },
        axisLabel: {
          textStyle: {
            fontSize: 16,
            color: '#fff'
          }
        }
      }]; // 渲染

      var option = {
        tooltip: tooltip,
        xAxis: xAxis,
        yAxis: yAxis,
        series: series,
        grid: grid,
        legend: legend
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);
      window.addEventListener('resize', function () {
        myChart.resize();
      }, false);
    },
    // 趋势数据
    querySewageQuotaList: function querySewageQuotaList(type, id, queryType) {
      var _this = this;

      queryInspectionAnalysis({
        type: type,
        id: id,
        queryType: queryType
      }).then(function (res) {
        if (res.success) {
          var dataA1 = [],
              dataA2 = [],
              dataB1 = [],
              dataB2 = [];
          var data = {
            xData: [],
            data1: [],
            data2: [],
            data3: [],
            data4: []
          };
          res.result.forEach(function (v, i) {
            data.xData.push(v.dateStr);
            data.data1.push(v.frequency);
            data.data2.push(v.warnFrequency);
            data.data3.push(v.weekFrequency);
            data.data4.push(v.weekWarnFrequency);
          });

          _this.initBarChart(data);
        }
      });
    }
  }
};